import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import hubspotSubmit from 'hubspot-form-submit';

import Button from '@marvelapp/marvel-ui/button';
import MaxWidth from '@marvelapp/marvel-ui/max-width';
import Spacing from '@marvelapp/marvel-ui/spacing';
import MessageBlock from '@marvelapp/marvel-ui/message-block';
import MarvelLink from '@marvelapp/marvel-ui/link';

import ContactUsInput from 'marketing-website/utils/forms/ContactUsInput';
import {
  isRequired,
  isEmailValid,
} from 'marketing-website/utils/forms/validation';
import { readCookie } from 'marketing-website/utils/params';
import { HUBSPOT_ID } from 'marketing-website/constants/api';
import { splitNames } from 'marketing-website/utils/forms';

const fields = [
  {
    label: 'Full Name',
    name: 'name',
    placeholder: "What's your full name?",
    validate: isRequired,
  },
  {
    label: 'Email address',
    name: 'email',
    type: 'email',
    placeholder: 'you@example.com',
    validate: [isRequired, isEmailValid],
  },
  {
    label: 'Message',
    name: 'message',
    placeholder: 'Write your message for the team here',
    validate: isRequired,
  },
];

class ContactForm extends React.Component {
  state = {
    formState: 'initial',
    isLoading: false,
  };

  submitForm = data => {
    this.setState({ isLoading: true });
    const { firstName, lastName } = splitNames(data.name);
    const gclid = readCookie('gclid');
    hubspotSubmit(HUBSPOT_ID, this.props.hubspotId, {
      company: data.company,
      email: data.email,
      firstname: firstName,
      lastname: lastName,
      message: data.message,
      gclid,
    })
      .then(() => {
        this.setState({
          formState: 'success',
          isLoading: false,
        });
      })
      .catch(() => {
        this.setState({
          formState: 'error',
          isLoading: false,
        });
      });

    if (typeof window !== `undefined` && window.dataLayer) {
      window.dataLayer.push({
        event: 'form-submitted-contact-us',
      });
    }
  };

  trackSubmissionWithHeap = (submittedSuccessfully, hasErrored) => {
    if (window.heap)
      if (submittedSuccessfully) {
        window.heap.track('Enterprise Form Submitted');
      } else if (hasErrored) {
        window.heap.track('Enterprise Form Error');
      }
  };

  render() {
    const { formState, isLoading } = this.state;
    const submittedSuccessfully = formState === 'success';
    const hasErrored = formState === 'error';
    this.trackSubmissionWithHeap(submittedSuccessfully, hasErrored);
    return (
      <MaxWidth display="block" value={400}>
        <form
          onSubmit={this.props.handleSubmit(this.submitForm)}
          noValidate
          method="post"
        >
          {hasErrored && (
            <MessageBlock type="error">
              There was an error submitting this form. Please try again or{' '}
              <MarvelLink
                url="https://help.marvelapp.com/"
                type="opaqueReversed"
                hasUnderline
                target="_blank"
              >
                contact support.
              </MarvelLink>
            </MessageBlock>
          )}
          {fields.map(field => (
            <Spacing key={field.name} type="margin" size="m" position="top">
              <Field
                component={ContactUsInput}
                fullWidth
                id={field.name}
                isTextarea={field.name === 'message'}
                label={field.label}
                minHeight={field.name === 'message' ? 120 : undefined}
                name={field.name}
                placeholder={field.placeholder}
                popoverPosition="right"
                popoverWidth={300}
                size="large"
                type={field.type || 'text'}
                validate={field.validate}
              />
            </Spacing>
          ))}
          <Spacing type="padding" size="m" position="top">
            <Button
              type="submit"
              size="large"
              background={submittedSuccessfully ? 'green' : 'blue'}
              hover={submittedSuccessfully ? 'green' : 'blue'}
              minWidth={110}
              fullWidth
              hasSucceeded={submittedSuccessfully}
              hasErrored={hasErrored}
              isStateful
              isLoading={isLoading}
            >
              Submit
            </Button>
          </Spacing>
        </form>
      </MaxWidth>
    );
  }
}

ContactForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  hubspotId: PropTypes.string.isRequired,
};

export default reduxForm({
  form: 'contactForm',
  touchOnBlur: false,
})(ContactForm);



// WEBPACK FOOTER //
// ./src/components/modules/ContactForm/index.js